/**
 * Custom Fullscreen Control for Mapbox
 * Expands map within its container section instead of full browser viewport
 */

class CustomFullscreenControl {
    constructor(options = {}) {
        this._onToggleFullscreen = options.onToggleFullscreen || null;
        this._container = options.container || null;
        this._map = null;
        this._btn = null;
        this._containerElement = null;
        this._isFullscreen = false;
    }

    onAdd(map) {
        this._map = map;

        // Create button element
        this._btn = document.createElement('button');
        this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-fullscreen';
        this._btn.type = 'button';
        this._btn.setAttribute('aria-label', 'Toggle fullscreen');
        this._btn.setAttribute('title', 'Toggle fullscreen');
        this._btn.onclick = () => this._toggleFullscreen();

        // Create container for the control
        this._containerElement = document.createElement('div');
        this._containerElement.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        this._containerElement.appendChild(this._btn);

        return this._containerElement;
    }

    onRemove() {
        if (this._containerElement && this._containerElement.parentNode) {
            this._containerElement.parentNode.removeChild(this._containerElement);
        }
        this._map = null;
        this._btn = null;
        this._containerElement = null;
    }

    _toggleFullscreen() {
        this._isFullscreen = !this._isFullscreen;

        // Update button appearance
        if (this._isFullscreen) {
            this._btn.classList.add('mapboxgl-ctrl-fullscreen-active');
        } else {
            this._btn.classList.remove('mapboxgl-ctrl-fullscreen-active');
        }

        // Call the callback if provided
        if (this._onToggleFullscreen) {
            this._onToggleFullscreen(this._isFullscreen);
        }
    }

    getDefaultPosition() {
        return 'top-right';
    }
}

export default CustomFullscreenControl;

